export default "__VITE_ASSET__CsbWSYEY__"